const modules = [
  {
    name: "Xentro 360",
    description: "Smarter workflows, better collaboration, total control.",
    basePath: "/app",
    logo: "/xentro_logo.png",
    baseAccessKey: "app",
    includeInList: false,
  },
  {
    name: "Support Central",
    description: "A streamlined hub for raising tickets and resolving issues. Customers get help fast, and support team works smarter—all in one place.",
    basePath: "/sc",
    logo: "/supportcentral_box.png",
    color: '#BBDEFB', 
    image: '/support_central_illustration.svg',
    baseAccessKey: "sc",
    hasOwnLoginPage: true,
  },
  {
    name: "Project Central",
    description: "Plan, track, and deliver projects—one central place for project management and delivery.",
    basePath: "/pms",
    logo: "/pms_logo.png",
    color: '#E3F2FD',
    image: '/project_central_logo.svg',
    baseAccessKey: "pms",
  },
  {
    name: "SaleStream",
    description: "Effortlessly manage leads, track deals, and boost revenue—all in one streamlined flow.",
    basePath: "/crm",
    logo: "/crm_logo.png",
    color: '#C5CAE9', 
    image: '/crm_illustration.svg',
    baseAccessKey: "crm",
  },
  {
    name: "Code Hub",
    description: "The central workspace for developers and QA teams to collaborate, build, test, and deliver flawless code—all in one place.",
    basePath: "/code_hub",
    logo: "/code_hub_logo.png",
    color: '#C8E6C9', 
    image: '/code_hub_illustration.svg',
    baseAccessKey: "code_hub",
  },
  {
    name: "FinanCore",
    description: "From invoicing to accounting, the comprehensive suite of tools for managing all financial aspects of a business.",
    basePath: "/fms",
    logo: "/fms_logo.png",
    color: '#F4E1E3', 
    image: '/fms_illustration.svg',
    baseAccessKey: "fms",
  },
];

export default modules;
